import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc8087e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { class: "popup_head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投票", -1))
const _hoisted_4 = { class: "table_content" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "table_box"
}
const _hoisted_7 = { style: {"height":"calc(100vh - 242px)","overflow":"scroll"} }
const _hoisted_8 = { class: "footer" }

import { ref } from 'vue';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons-vue';
import { Table, Switch, Input, Popover, Button, message } from 'ant-design-vue';
import http from '@/api';
import router from '@/router';
import { TableListClass } from './type';
import { emptyDataSec } from '@/assets';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import AppLink from '@/components/AppLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Vote',
  emits: ['close'],
  setup(__props, { emit }) {

const ATable = Table;
const aSwitch = Switch;
const aInputSearch = Input.Search;
const aPopover = Popover;
const aButton = Button;

// 获取投票列表
const studioId = router.currentRoute.value.params.studioId;
const tableList = ref<TableListClass[]>([]);
const arr = ref<TableListClass[]>([]);
const work = ref<TableListClass[]>([]);
const lastPage = ref(); //最后一页数据
const loadpageSize = ref(1); // 第几页数据
const noMore = ref(false); //判断是否有更多数据
const getVoteList = (current: any) => {
  const data = {
    studio_id: studioId,
    page: current,
    page_num: 20,
  };
  http.liveExpress.getVoteList({ params: data }).then((res) => {
    let list = res.data.data.data ? res.data.data.data.map((e: any) => new TableListClass(e)) : [];
    tableList.value.push(...list);
    lastPage.value = res.data.data.last_page;
    arr.value = tableList.value;
    work.value = tableList.value;
  });
};
getVoteList(1);
//滚动加载数据
const getChildList = () => {
  if (loadpageSize.value < lastPage.value) {
    noMore.value = false;
    loadpageSize.value++;
    getVoteList(loadpageSize.value);
  } else {
    noMore.value = true;
  }
};
// 投票开关
const setVoteSwitch = useDebounce((id: number) => {
  message.destroy();
  const data = {
    id: id,
  };
  http.liveExpress.setVoteSwitch(data).then((res) => {
    message.success(res.data.message);
  });
});
// 弹出
const votePopup = useDebounce((id: number) => {
  message.destroy();
  const data = {
    id: id,
  };
  http.liveExpress
    .votePopup(data)
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
});

// 搜索
const search = ref();
const onSearch = () => {
  if (search.value) {
    tableList.value = arr.value.filter((e: any) => e.theme.includes(search.value));
  } else {
    tableList.value = work.value;
  }
};

const columns = [
  {
    title: '题目名称',
    dataIndex: 'theme',
    key: 'theme',
    ellipsis: true,
  },
  {
    title: '开关',
    dataIndex: 'status',
    key: 'status',
    width: 110,
    align: 'center',
    slots: { customRender: 'switch' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    width: 110,
    align: 'center',
    slots: { customRender: 'operation' },
  },
];


const closeVote = () => {
  emit('close', false);
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "timing_return",
        onClick: closeVote
      }, [
        _createVNode(_unref(CloseOutlined))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(aInputSearch), {
        value: search.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        size: "small",
        class: "search",
        placeholder: "搜索题目名称",
        onSearch: onSearch
      }, null, 8, ["value"]),
      (tableList.value.length === 0)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(emptyDataSec),
            class: "null_img"
          }, null, 8, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createBlock(_unref(ATable), {
                columns: columns,
                "data-source": tableList.value,
                pagination: false,
                rowKey: "id"
              }, {
                switch: _withCtx(({ record }) => [
                  _createVNode(_unref(aSwitch), {
                    checked: record.status,
                    "onUpdate:checked": ($event: any) => ((record.status) = $event),
                    onChange: ($event: any) => (_unref(setVoteSwitch)(record.id)),
                    "checked-children": "开",
                    "un-checked-children": "关"
                  }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                ]),
                operation: _withCtx(({ record }) => [
                  _createVNode(_unref(aPopover), { placement: "top" }, {
                    content: _withCtx(() => [
                      _createTextVNode(" 弹出 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), {
                        type: "text",
                        onClick: ($event: any) => (_unref(votePopup)(record.id)),
                        class: "vote_prop"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "vote_eject" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["data-source"])), [
                [_directive_infinite_scroll, getChildList]
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(AppLink, {
        to: `/market/${_unref(studioId)}/vote`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(aButton), { class: "footer_but" }, {
            default: _withCtx(() => [
              _createVNode(_unref(PlusOutlined)),
              _createTextVNode("新建投票 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})